export default (value) => {
  let class_name = '';

  if (value >= 110 && value < 200) {
    class_name = 'h1';
  } else if (value >= 85 && value < 110) {
    class_name = 'h2';
  } else if (value >= 60 && value < 85) {
    class_name = 'h3';
  } else if (value >= 45 && value < 60) {
    class_name = 'h4';
  } else if (value >= 38 && value < 45) {
    class_name = 'h5';
  } else if (value >= 27 && value < 38) {
    class_name = 'h6';
  } else if (value >= 16 && value < 27) {
    class_name = 'h7';
  } else if (value >= 8 && value < 16) {
    class_name = 'p';
  }

  return class_name;
};
